import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router-dom'

import FaIcon from '../components/FaIcon'

import { List } from 'antd'



class Reports extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired
    }

    redirectToReport = (number) => {
        this.props.history.push('/reports/' + number)
    }

    render() {
        return (
            <div>
                <h1><FaIcon icon="chart-bar" fixedWidth /> <FormattedMessage id="reports.title" /></h1>
                <List itemLayout="horizontal" className="reports-list">
                    { [1, 2, 3, 4, 5, 6].map(number => <List.Item key={number} onClick={() => this.redirectToReport(number)}><FormattedMessage id={"reports.report" + number} /></List.Item>)}
                </List>
            </div>
        )
    }

}

export default withRouter(Reports)


// WEBPACK FOOTER //
// ./src/views/Reports.js